import { useIntegrationsHealth } from '@/api/studio';
import type { HealthStatus, IntegrationHealth } from '@/api/types';
import { formatAgo } from '@/lib/format';

const dot: Record<HealthStatus, string> = { ok: 'bg-done', failing: 'bg-overdue', unknown: 'bg-faint' };
const word: Record<HealthStatus, string> = { ok: 'работает', failing: 'не отвечает', unknown: 'нет данных' };

function detail(d: IntegrationHealth, now: Date): string {
  const ok = d.lastOkAt ? `последний успех ${formatAgo(d.lastOkAt, now)}` : 'успехов с запуска не было';
  if (d.status === 'failing' && d.lastErrorAt) return `${ok}; сбой ${formatAgo(d.lastErrorAt, now)}${d.error ? ` (${d.error})` : ''}`;
  return ok;
}

/** Owner only: which dependencies work and when each last did (MK42-5824). Colour only for status. */
export function IntegrationsHealth() {
  const { data } = useIntegrationsHealth(true);
  if (!data) return null;
  const now = new Date(data.generatedAt);

  return (
    <section className="rounded-lg p-5 shadow-hair" aria-label="Состояние интеграций">
      <h2 className="text-sm font-semibold">Состояние интеграций</h2>
      <ul className="mt-3 divide-y divide-line">
        {data.dependencies.map((d) => (
          <li key={d.key} className="flex flex-wrap items-center gap-3 py-2.5 text-sm">
            <span className={`size-2 shrink-0 rounded-full ${dot[d.status]}`} role="img" aria-label={word[d.status]} />
            <span className="min-w-0 flex-1">
              <span className="font-medium">{d.name}</span>
              {d.mode && (
                <span className="ml-2 rounded border border-line px-1.5 py-0.5 text-xs text-muted">
                  {d.mode === 'sandbox' ? 'песочница' : 'боевой'}
                  {d.provider ? ` · ${d.provider}` : ''}
                </span>
              )}
              <span className="block text-xs text-muted">{detail(d, now)}</span>
            </span>
            <span className="text-xs text-muted">{word[d.status]}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
